import { render, staticRenderFns } from "./Atividade_1.vue?vue&type=template&id=4be77101"
import script from "./Atividade_1.vue?vue&type=script&lang=js"
export * from "./Atividade_1.vue?vue&type=script&lang=js"
import style0 from "./Atividade_1.vue?vue&type=style&index=0&id=4be77101&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports